import React, { useReducer, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Send, CheckCircle, AlertCircle, Building, Users, Award, Globe, FileText, CheckSquare } from 'lucide-react';
import { SectionTitle, Row, Col, FormField, Input } from '../../../SharedInputs';
import { S } from '../../styles.js';

export function SectionReferees({ state, dispatch, errors }) {
  const updateReferee = (index, field, value) => {
    dispatch({ type: 'UPDATE_REFEREE', index, field, value });
  };

  return (
    <div>
      <SectionTitle icon={Users}>Referees</SectionTitle>
      <p style={S.hint}>Please provide details for at least two industry referees</p>
      
      {state.referees.map((referee, idx) => (
        <div key={idx} style={{ marginBottom: 32, padding: 20, background: '#f9fafb', borderRadius: 8 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, color: '#374151' }}>Referee {idx + 1}</h3>
          
          <Row>
            <Col span={6}>
              <FormField 
                label="Company Name" 
                required 
                error={errors.find(e => e.includes(`Referee ${idx + 1}`) && e.includes('Company name'))}
              >
                <Input
                  value={referee.companyName}
                  onChange={(e) => updateReferee(idx, 'companyName', e.target.value)}
                  placeholder="Company name"
                />
              </FormField>
            </Col>
            <Col span={6}>
              <FormField 
                label="Contact Person Name" 
                required 
                error={errors.find(e => e.includes(`Referee ${idx + 1}`) && e.includes('Contact name'))}
              >
                <Input
                  value={referee.contactName}
                  onChange={(e) => updateReferee(idx, 'contactName', e.target.value)}
                  placeholder="Full name"
                />
              </FormField>
            </Col>
          </Row>

          <Row>
            <Col span={4}>
              <FormField label="Position">
                <Input
                  value={referee.contactPosition}
                  onChange={(e) => updateReferee(idx, 'contactPosition', e.target.value)}
                  placeholder="Job title"
                />
              </FormField>
            </Col>
            <Col span={4}>
              <FormField label="Phone Number">
                <Input
                  type="tel"
                  value={referee.phone}
                  onChange={(e) => updateReferee(idx, 'phone', e.target.value)}
                  placeholder="+61 X XXXX XXXX"
                />
              </FormField>
            </Col>
            <Col span={4}>
              <FormField 
                label="Email Address" 
                required 
                error={errors.find(e => e.includes(`Referee ${idx + 1}`) && e.includes('Email'))}
              >
                <Input
                  type="email"
                  value={referee.email}
                  onChange={(e) => updateReferee(idx, 'email', e.target.value)}
                  placeholder="email@example.com"
                />
              </FormField>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
}